import ProjectCommons from "../project-commons";
import Toolbar from "../toolbar";
import SearchAutocomplete from "../search-autocomplete";
import TopDestacadoBadge from "../top-destacado-badge";
import {
    isMobileDevice,
    scrollTopList,
    setSearchTypeValue,
    translate
} from "../utils.esm";
import {initScrollTopBtn} from "../scroll-top";
import {customSelectW3} from "../custom-select";
import {customPageViewGa} from "../ga-custom";
import {listFn} from "../list-fn";
import {errorMsgs} from "../error-handler";
import {ModalAd} from "../modal-ad";


class ListPage {
    constructor() {
        console.log('init ListPage');

        if(!window) return;

        this.projectCommons = new ProjectCommons();

        const orderFilterParam = document.querySelector('.Search_orden');
        // noinspection JSUnresolvedReference
        this.orderGetParam = orderFilterParam && orderFilterParam.value ? orderFilterParam.value : 'default';

        this.infScroll = undefined;
        this.listOffset = window.adsLimit;
        this.currentOffset = window.listStartOffset;
        this.topDestacadoBadge = undefined;
        this.listAdCoverVideo = undefined;
        this.listAdCoverVideoPromise = undefined;
        this.modalAd = new ModalAd();

        if(window.isArticlePage) return;

        new Toolbar();
        this.autocomplete = new SearchAutocomplete('body', '#main-search-nombre');
        new SearchAutocomplete('#searchModal', '#main-search-nombre');

        if(window.searchQuery) customPageViewGa(window.searchQuery);

        if(window.projectSettingsOptions.autoboostEnabled)
            this.topDestacadoBadge = new TopDestacadoBadge();

        if(document.querySelector('#stories-section'))
            this.getStoriesJs().then(() => this.stories.initList());

        if(isMobileDevice)
            this.initFilterButtonMobile();

        const orderByDesk = document.querySelector('.order-by-desk');
        if(orderByDesk) { // when theres no results in `/search`
            const staticOrderTranslations = JSON.parse(
                orderByDesk
                    .getAttribute('data-labels')
            );

            this.orderItems = [{
                action: 'default',
                active: true,
            }, {
                action: 'date_desc',
                active: false,
            }];

            // TODO improvable but we avoid /get-i18n request on render
            this.orderItems = this.orderItems
                .map((orderItem, idx) => {
                    orderItem.label = staticOrderTranslations[idx];
                    return orderItem;
                });

            if(!isMobileDevice)
                this.initOrderSelectDesk();
        }

        setSearchTypeValue();
        this.setKmSelectDesk();

        initScrollTopBtn();
        this.initInfiniteScroll();

        if (document.querySelector('.list_item .short-description'))
            this.hideShortDescriptionOnScroll('.short-description');

        if (document.querySelector('.search-btn'))
            window.addEventListener('scroll', this.searchBtnScrollHandler);

        this.initListCards();

        const hash = parseInt(window.location.hash.replace(/#/g, ''));
        if(window.projectSettingsOptions.modalAdOnly && hash && !isNaN(hash))
            this.modalAd.displayModalAd(hash).then();
    }

    initListCards() {
        this.hideShortDescriptionOnScroll('.short-description');
        listFn.initListCardsCommons('listPage');
        this.coverVideoListeners();
    }

    hideShortDescriptionOnScroll(selector) {
        setTimeout(() => {
            window.addEventListener('scroll', () => {
                document.querySelectorAll(selector).forEach(element => {
                    if(element.closest('.list_item').classList.contains('category-vip')) element.parentElement.remove();
                    else element.remove();
                });
            }, {once: true});
        }, 300);
    }

    coverVideoListeners() {
        document.querySelectorAll('.list_item .ficha-pre-cover-video').forEach(preCoverEl => {
            const element = preCoverEl.closest('.list_item');
            const playBtnImg = element.querySelector('.list-item-img-video-overlay img[alt="vip-video"]');
            const cardImg = element.querySelector('.card-image');

            if(!playBtnImg || !cardImg) return;

            if(isMobileDevice) {
                playBtnImg.addEventListener('click', () => {
                    this.adTouchStartHandler(event, element);
                    cardImg.addEventListener('click', () => this.adMouseLeaveHandler(event, element), {once: true, passive: true});
                }, {passive: true});
            } else {
                playBtnImg.addEventListener('click', () => {
                    this.adMouseEnterHandler(event, element);
                    cardImg.addEventListener('click', () => this.adMouseLeaveHandler(event, element), {once: true, passive: true});
                }, {passive: true});
            }
        });
    }

    async getStoriesJs() {
        const {Stories} = await import("../stories");
        await import("../../lib/eros-stories-slider");
        this.stories = new Stories();
    }

    initOrderSelectDesk() {
        this.fillOrderSelectDesk();

        document.querySelector('.custom-select-w3 #order-by-desk').selectedIndex = 0;

        customSelectW3(document.querySelector('.custom-select-w3 #order-by-desk').parentElement, true);

        const label = document.querySelector('.order-by-desk .same-as-selected');
        const container = document.querySelector('.order-by-desk .select-selected');
        if(container && label) container.innerHTML = label.innerHTML; // fix para el label del select
    }

    initFilterButtonMobile() {
        const condition = document.querySelectorAll('#loadFavoritesContent').length;

        const el = document.querySelector('#filtersMobileBtn');
        if(!el) return;
        if(!condition) el.classList.add('show');
        else el.classList.remove('show');
    }

    fillOrderSelectDesk() {
        const select = document.querySelector('#order-by-desk');
        let selected = 0;
        this.orderItems.forEach((item, idx) => {
            let option = document.createElement('option');
            option.innerHTML = item.label;
            option.onclick = () => this.orderListBy(item.action, option);
            if(this.orderGetParam === item.action || (item.active && this.orderGetParam === null)) {
                option.classList.add('same-as-selected');
                option.selected = true;
                selected = idx;
            }

            select.appendChild(option);
        });

        setTimeout(() => {
            document.querySelector('#order-by-desk').selectedIndex = selected;
        }, 0);
    }

    async getInfiniteScroll(action = '', boolean = false, cb = () => {}) {
        const {ScrollList} = await import('../scroll-list');
        this.infScroll = new ScrollList(action, boolean).init(cb);
    }

    initInfiniteScroll() {
        window.addEventListener('scroll', async () => {
            if(!this.projectCommons.isSearchPage)
                await this.getInfiniteScroll();
        }, {once: true});
    }

    searchBtnScrollHandler() {
        const el = document.querySelector('.search-btn');
        const container = document.querySelector('#searchBtnContainer');
        if(!el || !container) return false;

        const containerPosY = container.getBoundingClientRect().top;
        if(containerPosY < 0)
            el.classList.add('active');
        else
            el.classList.remove('active');
    }

    listAreaDropdown(element) {
        const text = document.querySelector('.landing-text-result');
        if (element.parentElement.classList.contains('active')) {
            element.parentElement.classList.remove('active');
            text.parentElement.classList.remove('d-block');
            text.parentElement.classList.add('d-none');
        } else {
            element.parentElement.classList.add('active');
            text.parentElement.classList.add('d-block');
            text.parentElement.classList.remove('d-none');
        }

        this.fixListTopBadgeDesktop();
    }

    fixListTopBadgeDesktop() {
        const offset = 83;
        const el = document.querySelector('.list-top-badge');
        const firstHighlightedEl = document.querySelector('.list_item:first-child');
        if(!isMobileDevice && firstHighlightedEl && el) {
                // noinspection JSUnresolvedReference
                document.querySelector('.list-top-badge').style.top = (firstHighlightedEl.getBoundingClientRect().top - document.body.getBoundingClientRect().top - offset) + 'px';
            }
    }

    toggleCiudadesPrincipales(el) {
        if(el.classList.contains('opened') && el.previousElementSibling && el.previousElementSibling.classList.contains('category-vip')) el.className = 'col-12 col-lg-4 ciudades-principales-container scrolled';
        else if(el.classList.contains('opened')) el.className = 'col-6 col-lg-2 ciudades-principales-container scrolled';
        else el.className = 'col-12 col-lg-4 ciudades-principales-container scrolled opened';
    }

    async orderListBy(action, item) {
        if(action === 'default') window.location.reload();
        const currentOrderValue = document.querySelector('#currentOrderValue');
        if(currentOrderValue) currentOrderValue.value = action;

        this.currentOffset = 0;

        if(isMobileDevice)  {
            document.querySelectorAll('.order-selector-container li')
                .forEach(item => item.classList.remove('active'));
            item.classList.add('active');
        }

        if(this.projectCommons.isSearchPage) {
            document.querySelector('.Search_orden').value = action;
            if(isMobileDevice) {
                // noinspection JSUnresolvedReference
                document.querySelector('.btn-search input[type="submit"]').click();
            }
            else {
                // noinspection JSUnresolvedReference
                document.querySelector('.search button[type="submit"]').click();
            }
        }
        else {
            if(this.infScroll) this.infScroll.destroy();

            document.querySelectorAll('.list_item').forEach(listItem => listItem.remove());
            await this.getInfiniteScroll(action, true, () => this.currentOffset || scrollTopList());
            this.infScroll.loadNextPage();
        }

        if(isMobileDevice) setTimeout(() => this.hideOrderSelectors(), 300);
    }

    async showOrderSelectors() {
        const currentOrderInput = this.projectCommons.isSearchPage ?
            document.querySelector('.Search_orden') : document.querySelector('#currentOrderValue');
        // noinspection JSUnresolvedReference
        const currentOrderValue = currentOrderInput && currentOrderInput.value ? currentOrderInput.value : false;

        const backdrop = document.createElement('div');
        const container = document.createElement('div');
        container.classList.add('order-selector-container');
        backdrop.classList.add('order-selector-backdrop');
        const titleH2 = document.createElement('h2');
        translate({str: 'Organizar por:', element: titleH2});

        const ul = document.createElement('ul');

        this.orderItems.forEach(item => {
            let li = document.createElement('li');
            li.innerHTML = item.label;

            if(currentOrderValue === item.action || (item.active && currentOrderValue === false)) li.classList.add('active');
            li.onclick = () => this.orderListBy(item.action, li);
            ul.appendChild(li);
        });

        setTimeout(() => container.classList.add('show'), 100);

        backdrop.onclick = () => this.hideOrderSelectors();

        container.appendChild(titleH2);
        container.appendChild(ul);

        document.body.style.overflow = "hidden";
        document.body.appendChild(container);
        document.body.appendChild(backdrop);
    }

    hideOrderSelectors() {
        document.body.style.overflow = 'auto';
        if(document.querySelector('.order-selector-container'))
            document.querySelector('.order-selector-container').remove();

        if(document.querySelector('.order-selector-backdrop'))
            document.querySelector('.order-selector-backdrop').remove();
    }

    setKmSelectDesk() {
        document.querySelectorAll('#selectKilometer, #selectKilometers').forEach(select => {
            [1, 3, 5, 10, 50].forEach(km => select.innerHTML += `<option value="${km}">${km}km</option>`);
        });
    }

    async adTouchStartHandler(event, element) {
        event.stopPropagation();

        try {
            if(this.listAdCoverVideoPromise && element.querySelector('.ficha-cover-video') !== this.listAdCoverVideo)
                this.adMouseLeaveHandler(event, this.listAdCoverVideo.closest('.list_item'));

            await this.adMouseEnterHandler(event, element);
        } catch(err) {
            throw Error(errorMsgs.closestListAdCoverVideo);
        }
    }

    async adMouseEnterHandler(event, element) {
        event.stopPropagation();

        const pre = element.querySelector('span.ficha-pre-cover-video');
        if(pre) {
            const video = document.createElement('video');
            const source = document.createElement('source');
            source.src = pre.getAttribute('data-src');
            video.muted = true;
            video.playsInline = true;
            video.loop = true;
            video.className = 'ficha-cover-video';
            video.appendChild(source);
            pre.parentElement.insertBefore(video, pre);
            pre.remove();
        }
        await this.adPlayVideo(element);
        element.classList.add('vip-hover-effect');
    }
    adMouseLeaveHandler(event, element) {
        if(event) event.stopPropagation();

        this.adStopRewindVideo(element);
        element.classList.remove('vip-hover-effect');
    }

    async adPlayVideo(element) {
        this.listAdCoverVideo = element.querySelector('.ficha-cover-video');
        if(this.listAdCoverVideo) this.listAdCoverVideoPromise = await this.listAdCoverVideo.play();
    }

    adStopRewindVideo(element) {
        const video = element.querySelector('.ficha-cover-video');
        if(video && this.listAdCoverVideoPromise !== undefined) {
            this.listAdCoverVideoPromise.then(_ => {
                video.pause();
                video.currentTime = 0;
                this.listAdCoverVideoPromise = undefined;
            });
        }
    }

}
window.listPage = new ListPage();